
import React, { useState, useCallback } from "react";
import {
    QuestionCircleOutlined
} from '@ant-design/icons';
import UseMemo from "@/components/Memo";
import styles from "./index.scss";
// import FormComponent from "./Form";
import FormComponent from "./PhoneForm";

function IframeWechart(props: any) {
    const { onClose, loginTypeIsAccount } = props;
    return (
        <div className={styles.wechatLoginDiv} style={{ display: loginTypeIsAccount ? "none" : "flex" }}>
            <div className={styles.closeDiv} onClick={onClose} />
            <div>
                <iframe sandbox="allow-scripts allow-top-navigation allow-same-origin" scrolling="no" width="300" height="400" frameBorder="0" title="微信扫码登录" src="https://open.weixin.qq.com/connect/qrconnect?appid=wxc4616be1c0ea82d5&redirect_uri=https://video.shine.cn/wechat/login&response_type=code&scope=snsapi_login&state=123#wechat_redirect" />
            </div>
        </div>
    );
}

function onCloseWechat(setLoginTypeIsAccount: any) {
    return () => {
        setLoginTypeIsAccount(true);
    };
}

function Login(props: any) {
    const [loginTypeIsAccount, setLoginTypeIsAccount] = useState(true);
    const [divLeftText, setDivLeftText] = useState("账号登录");

    const onClickSwitchLogin = useCallback(() => {
        const isLoginType = !loginTypeIsAccount;
        const divLeftTextNew = isLoginType ? "账号登录" : "扫码登录";
        setLoginTypeIsAccount(isLoginType);
        setDivLeftText(divLeftTextNew);
    }, [loginTypeIsAccount]);

    const onCloseEvent = useCallback(onCloseWechat(setLoginTypeIsAccount), []);

    return (
        <div className={styles.container}>
            <div className={styles.loginItems}>
                <div className={styles.loginItemsContainer} style={{ display: loginTypeIsAccount ? "" : "none" }}>
                    <div className={styles.textHeader}>
                        欢迎登录
                            </div>
                    <div className={styles.textDes}>
                        视频资源库
                            </div>
                    <div className={styles.textInfo}>
                        <div className={styles.divLeft}>
                            {divLeftText}
                        </div>
                        <div className={styles.divRight}>
                            <div className={styles.textImg + " " + (loginTypeIsAccount ? styles.saomaImg : styles.normalImg)} onClick={onClickSwitchLogin} />
                        </div>
                    </div>
                    {loginTypeIsAccount ? <UseMemo deps={[]}>
                        {
                            () => <FormComponent {...props} />
                        }
                    </UseMemo> : null}
                    <div className={styles.textFooter + " " + (loginTypeIsAccount ? styles.alignRight : styles.alignCenter)}>
                        {
                            loginTypeIsAccount ? <QuestionCircleOutlined className={styles.iconMargin} /> : <div className={styles.iconSaoyiSao} />
                        }
                        {
                            loginTypeIsAccount ? "如有问题，请找管理员协助" : "打开微信扫一扫登录"
                        }
                    </div>
                </div>
                <IframeWechart onClose={onCloseEvent} loginTypeIsAccount={loginTypeIsAccount} />
            </div>
        </div>
    );
}

export default Login;



